import { render } from "./BaseLink.vue?vue&type=template&id=c0198d66&scoped=true"
import script from "./BaseLink.vue?vue&type=script&lang=ts"
export * from "./BaseLink.vue?vue&type=script&lang=ts"

import "./BaseLink.vue?vue&type=style&index=0&id=c0198d66&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c0198d66"

export default script